import { getCadastroAdicional } from '@/utils/cadastros-adicionais-utils';
import CadastrosAdicionais from '@/enums/cadastros-adicionais';
import { ErpCamposIntegracao, TipoProduto } from 'px-business-components';

const hasCamposAdicionaisErpTotvs = camposIntegracao => camposIntegracao.armazem !== null;

const hasCamposAdicionaisErpTotvsProtheus = camposIntegracao => camposIntegracao
  .contaContabil !== null;

const hasCamposAdicionaisErpM365BuscheLepper = camposIntegracao => camposIntegracao
  .segmento !== null;

const hasCamposAdicionaisErpCrmSolucoes = camposIntegracao => camposIntegracao
  .contaDespesa !== null;

const hasCamposAdicionaisErpSeniorMega = camposIntegracao => camposIntegracao.operacao !== null
  && camposIntegracao.contaFinanceira !== null;

const hasCamposAdicionaisErpFocco = camposIntegracao => camposIntegracao.contaFinanceira !== null;

const hasCamposAdicionaisErpCasaShopping = camposIntegracao => camposIntegracao
  .contaDespesa !== null;

const hasCamposAdicionaisErpSapB1 = camposIntegracao => camposIntegracao.armazem !== null;

const hasCamposAdicionaisErpSeniorPfiffner = camposIntegracao => camposIntegracao.armazem !== null;

const hasCamposAdicionaisErpEliteSoft = camposIntegracao => camposIntegracao
  .contaFinanceira !== null;

export const hasCamposAdicionaisErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return hasCamposAdicionaisErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return hasCamposAdicionaisErpTotvsProtheus(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return hasCamposAdicionaisErpM365BuscheLepper(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return hasCamposAdicionaisErpCrmSolucoes(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return hasCamposAdicionaisErpSeniorMega(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return hasCamposAdicionaisErpCasaShopping(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return hasCamposAdicionaisErpFocco(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return hasCamposAdicionaisErpSapB1(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return hasCamposAdicionaisErpSeniorPfiffner(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.ELITE_SOFT.key) {
    return hasCamposAdicionaisErpEliteSoft(camposIntegracao);
  }
  return false;
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Armazém é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpTotvsProtheus = (camposIntegracao) => {
  if (!camposIntegracao.contaContabil) {
    return [false, 'A conta contábil é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpM365BuscheLepper = (camposIntegracao) => {
  if (!camposIntegracao.segmento) {
    return [false, 'Segmento é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpCrmSolucoes = (camposIntegracao) => {
  if (!camposIntegracao.contaDespesa) {
    return [false, 'A conta de despesa é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSeniorMega = (camposIntegracao) => {
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'A classe financeira é obrigatória'];
  }
  if (!camposIntegracao.operacao) {
    return [false, 'A operação é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpFocco = (camposIntegracao) => {
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'A conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpCasaShopping = (camposIntegracao) => {
  if (!camposIntegracao.contaDespesa) {
    return [false, 'A conta de é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSapB1 = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'O depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpSeniorPfiffner = (camposIntegracao, produto) => {
  if (!camposIntegracao.armazem
      && (produto?.tipoProduto === TipoProduto.keys.PRODUTO.key || !produto)) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpEliteSoft = (camposIntegracao) => {
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'A conta é obrigatória'];
  }
  return [true, null];
};


export const validateCamposErp = (tipoErp, camposIntegracao, produto) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return validateCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return validateCamposErpTotvsProtheus(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return validateCamposErpM365BuscheLepper(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return validateCamposErpCrmSolucoes(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return validateCamposErpSeniorMega(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return validateCamposErpFocco(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return validateCamposErpCasaShopping(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return validateCamposErpSapB1(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return validateCamposErpSeniorPfiffner(camposIntegracao, produto);
  }
  if (tipoErp === ErpCamposIntegracao.keys.ELITE_SOFT.key) {
    return validateCamposErpEliteSoft(camposIntegracao);
  }
  return [true, null];
};

export const computeFrom = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.ARMAZEM.key),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.ARMAZEM.key),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return {
      segmento: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.SEGMENTO.key),
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return {
      contaDespesa: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_DESPESA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return {
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
      operacao: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.OPERACAO.key),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_DESPESA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_DESPESA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CONDOR.key) {
    return {
      contaContabil: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.ARMAZEM.key),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.ARMAZEM.key),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.ELITE_SOFT.key) {
    return {
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  return {};
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return {
      armazem: null,
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return {
      segmento: null,
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CRM_SOLUCOES.key) {
    return {
      contaDespesa: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEGA.key) {
    return {
      contaFinanceira: null,
      operacao: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CONDOR.key) {
    return {
      contaContabil: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return {
      armazem: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.ELITE_SOFT.key) {
    return {
      contaFinanceira: null,
    };
  }
  return {};
};
